import { HeaderSearch } from './HeaderSearch';

export function Header2() {
  return <HeaderSearch />;
}
